// import React, { useEffect, useState } from "react";
// import classes from "./HomePage.module.css";
// import { fetchContentApi } from "./http";
// import { useNavigate, useSearchParams } from "react-router-dom";

// const HomePage = () => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedVideo, setSelectedVideo] = useState(null);

//   const navigate = useNavigate();

//   const [searchParams, setSearchParams] = useSearchParams();

//   useEffect(() => {
//     if (searchParams.get("msisdn")) {
//       localStorage.setItem("msisdn", searchParams.get("msisdn"));
//     }
//     else if (!searchParams.get("msisdn") && !localStorage.getItem("msisdn")) {
//       navigate("/subscribe");
//     }
//     else {
//       console.log("no");
//     }
//   }, [searchParams, localStorage]);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const result = await fetchContentApi();
//         setData(result?.data?.result || []);
//       } catch (err) {
//         setError(err.message || "Something went wrong while fetching insights");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   // Close modal on ESC key
//   useEffect(() => {
//     const handleEsc = (e) => {
//       if (e.key === "Escape") {
//         setSelectedVideo(null);
//       }
//     };
//     window.addEventListener("keydown", handleEsc);
//     return () => window.removeEventListener("keydown", handleEsc);
//   }, []);

//   if (loading) {
//     return (
//       <div className={classes.loading}>
//         <div className={classes.spinner} />
//         <p>🌱 Cultivating fresh insights...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return <div className={classes.error}>⚠ {error}</div>;
//   }

//   const activeData = data.filter((item) => item.status === 1);

//   return (
//     <div className={classes.container}>
//       <div className={classes.wrapper}>
//         <header className={classes.sectionHeader}>
//           <h1>🌾 Agriczone</h1>
//           <p>Growing Knowledge • Cultivating Success</p>
//         </header>

//         <div className={classes.grid}>
//           {activeData.map((item) => (
//             <article
//               key={item.id}
//               className={classes.card}
//               onClick={() => setSelectedVideo(item.video)}
//             >
//               <div className={classes.imageWrapper}>
//                 <img
//                   src={item.image}
//                   alt={item.name}
//                   className={classes.image}
//                   loading="lazy"
//                 />
//               </div>

//               <div className={classes.content}>
//                 <h2>{item.name}</h2>
//                 <div className={classes.footer}>
//                   <span className={classes.readMore}>Watch →</span>
//                 </div>
//               </div>
//             </article>
//           ))}
//         </div>

//         {activeData.length === 0 && (
//           <p className={classes.noData}>No active insights available yet.</p>
//         )}
//       </div>

//       {/* MODAL */}
//       {selectedVideo && (
//         <div
//           className={classes.modalOverlay}
//           onClick={() => setSelectedVideo(null)}
//         >
//           <div
//             className={classes.modal}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               className={classes.closeBtn}
//               onClick={() => setSelectedVideo(null)}
//             >
//               ✕
//             </button>

//             <video
//               src={selectedVideo}
//               controls
//               autoPlay
//               className={classes.videoPlayer}
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default HomePage;





import React, { useEffect, useState } from "react";
import classes from "./HomePage.module.css";
import { fetchContentApi, unsubscribeApi } from "./http";
import { useNavigate, useSearchParams } from "react-router-dom";

const HomePage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const [showUnsubscribeModal, setShowUnsubscribeModal] = useState(false);
  const [unsubscribing, setUnsubscribing] = useState(false);
  const [unsubscribeMessage, setUnsubscribeMessage] = useState("");
  const [unsubscribeSuccess, setUnsubscribeSuccess] = useState(false);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const msisdn = searchParams.get("msisdn");

    if (msisdn) {
      localStorage.setItem("msisdn", msisdn);
    } else if (!localStorage.getItem("msisdn")) {
      navigate("/subscribe", { replace: true });
    }
  }, [searchParams, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await fetchContentApi();
        setData(result?.data?.result || []);
      } catch (err) {
        setError(
          err.message || "Something went wrong while fetching insights"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setSelectedVideo(null);

        if (!unsubscribing) {
          setShowUnsubscribeModal(false);
        }
      }
    };

    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [unsubscribing]);

  // Handle Unsubscribe
  const handleUnsubscribe = async () => {
    const msisdn = localStorage.getItem("msisdn");

    if (!msisdn) {
      setUnsubscribeMessage("MSISDN not found. Please subscribe again.");
      setUnsubscribeSuccess(false);
      return;
    }

    if (unsubscribing) return;

    setUnsubscribing(true);
    setUnsubscribeMessage("");

    try {
      const response = await unsubscribeApi(msisdn);

      // Backend should return success: true only after
      // Telecel confirms successful deactivation.
      // if (response?.data?.success === true) {
      setUnsubscribeSuccess(true);
      setUnsubscribeMessage(
        "You have successfully unsubscribed from Agriczone. You will no longer be charged for this service."
      );

      localStorage.removeItem("msisdn");
      // } else {
      //   throw new Error(
      //     response?.data?.message ||
      //     "Unable to unsubscribe. Please try again."
      //   );
      // }
    } catch (err) {
      console.error("Unsubscribe Error:", err);

      setUnsubscribeSuccess(false);
      setUnsubscribeMessage(
        err.response?.data?.message ||
        err.message ||
        "Unsubscription failed. Please try again."
      );
    } finally {
      setUnsubscribing(false);
    }
  };

  const closeUnsubscribeModal = () => {
    if (unsubscribing) return;

    setShowUnsubscribeModal(false);

    if (unsubscribeSuccess) {
      navigate("/subscribe", { replace: true });
    }

    setUnsubscribeMessage("");
  };

  if (loading) {
    return (
      <div className={classes.loading}>
        <div className={classes.spinner} />
        <p>🌱 Cultivating fresh insights...</p>
      </div>
    );
  }

  if (error) {
    return <div className={classes.error}>⚠ {error}</div>;
  }

  const activeData = data.filter(
    (item) => Number(item.status) === 1
  );

  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>


        <header className={classes.sectionHeader}>
          <div className={classes.headerTop}>
            <div className={classes.headerTitle}>
              <h1>🌾 Agriczone</h1>
              <p>Growing Knowledge • Cultivating Success</p>
            </div>

            <button
              className={classes.unsubscribeBtn}
              onClick={() => {
                setUnsubscribeMessage("");
                setUnsubscribeSuccess(false);
                setShowUnsubscribeModal(true);
              }}
            >
              Unsubscribe
            </button>
          </div>
        </header>



        {/* <header className={classes.sectionHeader}>
          <h1>🌾 Agriczone</h1>
          <p>Growing Knowledge • Cultivating Success</p>
        </header> */}

        <div className={classes.grid}>
          {activeData.map((item) => (
            <article
              key={item.id}
              className={classes.card}
              onClick={() => setSelectedVideo(item.video)}
            >
              <div className={classes.imageWrapper}>
                <img
                  src={item.image}
                  alt={item.name}
                  className={classes.image}
                  loading="lazy"
                />
              </div>

              <div className={classes.content}>
                <h2>{item.name}</h2>

                <div className={classes.footer}>
                  <span className={classes.readMore}>
                    Watch →
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        {activeData.length === 0 && (
          <p className={classes.noData}>
            No active insights available yet.
          </p>
        )}


      </div>

      {/* VIDEO MODAL */}
      {selectedVideo && (
        <div
          className={classes.modalOverlay}
          onClick={() => setSelectedVideo(null)}
        >
          <div
            className={classes.modal}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className={classes.closeBtn}
              onClick={() => setSelectedVideo(null)}
            >
              ✕
            </button>

            <video
              src={selectedVideo}
              controls
              autoPlay
              className={classes.videoPlayer}
            />
          </div>
        </div>
      )}

      {/* UNSUBSCRIBE CONFIRMATION MODAL */}
      {showUnsubscribeModal && (
        <div
          className={classes.confirmOverlay}
          onClick={closeUnsubscribeModal}
        >
          <div
            className={classes.confirmModal}
            role="dialog"
            aria-modal="true"
            aria-labelledby="unsubscribeTitle"
            onClick={(e) => e.stopPropagation()}
          >

            <div className={classes.confirmIcon}>
              {unsubscribeSuccess ? "✓" : "🌱"}
            </div>

            <h2 id="unsubscribeTitle">
              {unsubscribeSuccess
                ? "Unsubscribed Successfully"
                : "Confirm Unsubscription"}
            </h2>

            {!unsubscribeMessage && (
              <p>
                Are you sure you want to unsubscribe from
                Agriczone?
                <br />
                You will lose access to the service after
                successful unsubscription.
              </p>
            )}

            {unsubscribeMessage && (
              <p
                className={
                  unsubscribeSuccess
                    ? classes.successMessage
                    : classes.errorMessage
                }
                role="status"
              >
                {unsubscribeMessage}
              </p>
            )}

            <div className={classes.confirmActions}>

              {!unsubscribeSuccess && (
                <button
                  className={classes.cancelBtn}
                  onClick={closeUnsubscribeModal}
                  disabled={unsubscribing}
                >
                  Cancel
                </button>
              )}

              {!unsubscribeSuccess ? (
                <button
                  className={classes.confirmUnsubscribeBtn}
                  onClick={handleUnsubscribe}
                  disabled={unsubscribing}
                >
                  {unsubscribing
                    ? "Unsubscribing..."
                    : "Yes, Unsubscribe"}
                </button>
              ) : (
                <button
                  className={classes.doneBtn}
                  onClick={closeUnsubscribeModal}
                >
                  Done
                </button>
              )}

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomePage;
